import React from 'react';
import { useLocation } from 'react-router-dom';
import { profilesApi } from '../../../api/profiles';
import CircleChart from '../../../components/ui/CircleChart';
import NotableInvestments from '../../../components/ui/NotableInvestments';
import { isWalletAddress } from '../../../utils/supportedBlockchains';
import Interests from './Interests';
import MultiChainActivity from './MultiChainActivity';

const Portfolio = ({
  total,
  distributionData,
  address,
  multiChainData,
  isLoading,
}) => {
  const { pathname } = useLocation();

  const {
    currentData: notableInvestments,
    isLoading: isNotableInvestmentsLoading,
    isFetching: isNotableInvestmentsFetching,
  } = profilesApi.useGetWalletNotableInvestmentsQuery(
    isWalletAddress(pathname.split('/')[2])
      ? `?address=${pathname.split('/')[2]}`
      : `?alid=${pathname.split('/')[2]}&address=${address || ''}`,
    {
      skip: !isWalletAddress(pathname.split('/')[2]) && !address,
    }
  );

  const {
    currentData: walletInterests,
    isLoading: isWalletInterestsLoading,
    isFetching: isWalletInterestsFetching,
  } = profilesApi.useGetWalletInterestsQuery(
    isWalletAddress(pathname.split('/')[2])
      ? `?address=${pathname.split('/')[2]}`
      : `?alid=${pathname.split('/')[2]}&address=${address || ''}`,
    {
      skip: !isWalletAddress(pathname.split('/')[2]) && !address,
    }
  );

  return (
    <>
      <div className="row">
        <div className="col-12 col-lg-6 col-xl-4">
          <NotableInvestments
            text="tokens"
            isLoading={
              isNotableInvestmentsLoading ||
              isNotableInvestmentsFetching ||
              isLoading
            }
            data={notableInvestments?.tokens}
            holders={total}
            valueBased
            info="Relevant tokens held by profile"
          />
        </div>
        <div className="col-12 col-lg-6 col-xl-4 mt-4 mt-lg-0">
          <NotableInvestments
            text="NFTs"
            isLoading={
              isNotableInvestmentsLoading ||
              isNotableInvestmentsFetching ||
              isLoading
            }
            data={notableInvestments?.nfts}
            holders={total}
            valueBased
            info="Relevant NFTs held by profile"
          />
        </div>
        <div className="col-12 col-lg-6 col-xl-4 mt-4 mt-xl-0">
          <CircleChart
            title="Portfolio Distribution"
            data={distributionData.filter((token) => token.percent > 0)}
            sort="desc"
          />
        </div>
      </div>
      <div style={{ marginTop: '32px' }}>
        <MultiChainActivity
          multiChainData={multiChainData}
          isLoading={isLoading}
        />
      </div>
      <div>
        <Interests
          isLoading={isWalletInterestsLoading}
          isFetching={isWalletInterestsFetching}
          walletInterests={walletInterests}
        />
      </div>
    </>
  );
};

export default Portfolio;
